module.exports = __webpack_public_path__ + "img/measure-and-change-logo-black.8ee43345.png";